@if (windowService.isDesktopRes) {
  <tidy-desktop-header #wifiHeader>
    <div class="wrappable-container">
      <tidy-text [header]="'Wi-Fi Marketing'" />
      <form [formGroup]="searchForm" novalidate action="#">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search'"
          [icon]="'assets/img/search-header.svg'"
          class="header-search" />
      </form>
    </div>
    <div class="non-wrappable-right-aligned-container">
      <automations-preview-button
        [tag]="'wifi-marketing'" />
    </div>
  </tidy-desktop-header>
}

<!-- Skeleton table while loading — rows float in with the entrance cascade;
     the real table below then replaces it in place, instantly (skipEntrance). -->
@if (windowService.isDesktopRes && !loaded) {
  <tidy-table
    [skeletonLoading]="true"
    [columnslabels]="headers" />
}

@if (loaded) {
  <sensor-promo-card (orderClick)="openOrderSensor()" (learnMoreClick)="openHardwareInfo()" />

  @if (windowService.isDesktopRes) {
    @if (rows.length > 0) {
      <tidy-table
        [dataSource]="rows"
        [displayedColumns]="headers"
        [columnslabels]="headers"
        [showColumnLines]="false"
        [rowsToShow]="50"
        [allRowIsClickable]="true"
        [skipEntrance]="true"
        (cellClick)="onTableRowClick($event)"
        [infiniteScroll]="false"
        [totalRows]="rows.length" />
    }
    @if (rows.length === 0) {
      <tidy-alert>
        <tidy-row>
          <tidy-text [body]="'No Wi-Fi devices found.'" />
        </tidy-row>
      </tidy-alert>
    }
  }

  @if (!windowService.isDesktopRes) {
    <form [formGroup]="searchForm" novalidate action="#" style="margin-bottom: 10px;">
      <tidy-search-input
        formControlName="search"
        [placeholder]="'Search'"
        [icon]="'assets/img/search-header.svg'"
        class="header-search" />
    </form>
    @for (row of rows; track $index) {
      <tidy-card>
        <tidy-card-button (action)="onTableRowClick(row)" class="arrow-to-top">
          <tidy-row class="vertical-align-center">
            <tidy-text [body]="row['Property'].value" [translate]="false" />
          </tidy-row>
          <tidy-row [alignLastItemRight]="true">
            <tidy-text [helper]="row['Access Points'].value" [translate]="false" />
            <tidy-text [helper]="row['Wi-Fi Status'].value" [translate]="false" />
          </tidy-row>
        </tidy-card-button>
      </tidy-card>
    }
    @if (rows.length === 0) {
      <tidy-alert>
        <tidy-row>
          <tidy-text [body]="'No Wi-Fi devices found.'" />
        </tidy-row>
      </tidy-alert>
    }
  }
}

@if (showAboutThisPage) {
  <tidy-about-this-page [page]="'wifi-marketing'" [overlayTop]="overlayTop" (dismissed)="dismissAboutThisPage()" />
}
